// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#root {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* https://github.com/reach/router/issues/63 */\n#router,\n[data-testid=\"responsive-view\"],\n[data-testid=\"responsive-view\"] > div {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n/* Chrome, Safari and Opera */\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.no-scrollbar {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n", ""]);
// Exports
module.exports = exports;
